module.exports = __webpack_public_path__ + "static/media/envelope-check.fbea22bc.svg";